<div class="table-placeholder__icon-container">
	<span [tuiAvatar]="icon()" [size]="iconSize()" tuiAvatarOutline></span>
</div>

<h3 class="mt-4 mb-0 {{ headerSize() }}">
	{{ header() }}
</h3>

<p class="mt-2 {{ contentSize() }}">
	{{ content() }}
</p>
